// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__KzJqW","notes":"Notes_notes__2GS1c"};